import React, { Fragment } from 'react';

import MaterialTable from 'material-table';
import { Badge, Paper, Tooltip } from '@material-ui/core'; 
import { createStyles, Theme, withStyles } from '@material-ui/core/styles';

import GhaWhPoAwbLocation from '../../../models/GhaWhPoAwbLocation';
import OrderWhsDetails from '../../../models/OrderWhsDetails';
import { OrderLockStatusType } from '../../../models/OrderLockStatusType.enum';
import { AttachFile, CameraAlt as Camera } from '@material-ui/icons';
import commonStyles from '../../common/common.module.css';


const styles = (theme: Theme) =>

  createStyles({
    PoD: {
      color: 'inherit',
      textDecoration: 'underline',
      cursor: 'pointer',
    },
    awbActionsList: {
      display: 'flex',
      flexDirection: 'row',
      width: '95%',
      justifyContent: 'space-between'
    },
    disabledBadgeIcon: {
      '&>span': {
        color: 'rgb(204, 204, 204)',
        borderColor: 'rgb(204, 204, 204)'
      }
    },
    materialIcon: {
      '&:hover': {
        cursor: 'pointer'
      }
    }
  });

interface WhsPoDetailsTableProps {
  classes: any;
  pickupOrder: OrderWhsDetails;
  selectedAwb: string;
  handleChangeAwb: (awbNumber: string, version: number) => void;
  handleOpenPoD: (awbCode: string, awbNumber: string, version: number) => void;
  openDialog: (type: string, awbCode: string, awbNumber: string, version: number) => void;
  uploadFile: (event: any, awbCode: string, awbNumber: string, version: number) => void;
};

const whsPoDetailsTable = (props: WhsPoDetailsTableProps) => {

  const { pickupOrder } = props;
  const disabled: boolean = pickupOrder.status === 'delivered' || pickupOrder.lock_status !== OrderLockStatusType.LOCKED;
  let awbListLocation = [... pickupOrder.awb_location_list];
  let awbList = [... pickupOrder.list]
  for (let item of awbListLocation) {
    const awb = awbList.find( (awbItem: any) => {
      return awbItem.code === item.code && awbItem.number === item.number
    });
    if (awb) {
      item.status = awb.status
    }
  }

  return (
    <MaterialTable
      onRowClick={ (event: any, rowData: any) => props.handleChangeAwb(rowData.code + '-' + rowData.number, rowData.version) }

      components={{Container: props => <Paper {...props} elevation={0} className={`${ commonStyles.paperTable } ${ commonStyles.SelectTable }`}/>}}

      data={ awbListLocation } 

      columns={[

        { title: 'Awb', field: 'awb', cellStyle: { padding: 0, margin: 0 }, headerStyle: { padding: '10px 0 10px 0', height: '1%' },
          render: (rowData: GhaWhPoAwbLocation) => { 

            return <span><span className={ commonStyles.spaceNowrap }>{ rowData.code }-{ rowData.number }</span> {rowData.returned? <span style={{color: 'red'}}>Returned to driver</span>: null}</span>;
          }
        },
        { title: '', cellStyle: { width: '8%' }, headerStyle: { width: '8%' },
          render: (rowData: GhaWhPoAwbLocation) => {
            if (rowData.status === 'SHIPMENT DELIVERED' || rowData.status === 'SHIPMENT PARTIALLY DELIVERED' ||
                rowData.status === 'SHIPMENT REJECTED' || rowData.status === 'SHIPMENT PARTIALLY REJECTED') {
            return (
              <span>
                <span className={ props.classes.PoD } onClick={ () => props.handleOpenPoD(rowData.code , rowData.number, rowData.version) }>PoD</span>
              </span>
            )
            } return null
          }},
        { title: 'Pcs', field: 'pieces', cellStyle: { padding: 0, margin: 0, width: '15%' }, headerStyle: { padding: '10px 0 10px 0', width: '15%', height: '1%' } },
        { title: 'Location', field: 'location', cellStyle: { padding: 0, margin: 0, width: '33%' }, headerStyle: { padding: '10px 0 10px 0', width: '33%', height: '1%' } },
        { title: 'Notes', field: 'info_to_wh', render: (rowData: GhaWhPoAwbLocation) => {
          let remark = (rowData.info_to_wh)? rowData.info_to_wh : ''
          return remark
        }, cellStyle: { padding: 0, margin: 0, width: '30%' }, headerStyle: { padding: '10px 0 10px 0', width: '35%', height: '1%' }},
        { title: 'Action',
        render: (rowData: GhaWhPoAwbLocation) => {
          return <span className={ props.classes.awbActionsList }>
              <Tooltip title="View Attachments">
                <span className={ `${commonStyles.mr2 }` }>
                  <Badge className={ `${commonStyles.attachmentBadge}` } color="secondary" badgeContent={ rowData.attachmentCount }>
                    <AttachFile className={ props.classes.materialIcon } onClick={ (events) => props.openDialog('attachments', rowData.code, rowData.number, rowData.version) }/>
                  </Badge>
                </span>
              </Tooltip>
              <Tooltip title="Attach file">
                <Fragment>
                  <Camera className={ props.classes.camera } onClick={ (event) => props.uploadFile(event, rowData.code, rowData.number, rowData.version) }/>
                  <input id="fileUpload" hidden type="file"  name="attachment" onChange={ (event) => props.uploadFile(event, rowData.code, rowData.number, rowData.version) }/>
                </Fragment>
              </Tooltip>
             </span>
        }
        }
      ]}

      options={{
        maxBodyHeight: 205,
        paging: false,
        pageSize: 10,
        headerStyle: {
          backgroundColor: 'var(--tbl_head_bkg)',
            color: 'var(--tbl_head_color)',
            zIndex: 2,
        },
        rowStyle: ( rowData: GhaWhPoAwbLocation ) => ({
          color: ( props.selectedAwb === ( rowData.code + '-' + rowData.number )) ? '#fff' : '#000',
      }),
        showTitle: false,
        pageSizeOptions: [15, 20],
        toolbar: false,
        sorting: false
      }}
    />
  );
};

export default withStyles(styles)(whsPoDetailsTable);